module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5IiBoZWlnaHQ9IjUiPjxwYXRoIGQ9Ik0xLjM4Ny4yTDQuNSAzLjE4MiA3LjYxMy4yQS44LjggMCAwIDEgOC42MzEuMTI3TDguNzIuMmwuMDM3LjAzNi4wMjQuMDI0Yy4zLjMxMy4yOS44MS0uMDI0IDEuMTA4aDBMNS4xNzYgNC44YS44LjggMCAwIDEtLjY3Ni4yMTMuOC44IDAgMCAxLS42NzYtLjIxM2wtMy41OC0zLjQzQy0uMDcgMS4wNy0uMDguNTcyLjIyLjI2TC4yNDMuMjM2LjI4LjJhLjguOCAwIDAgMSAxLjEwNyAweiIgZmlsbD0iIzhkYTBhYiIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_arrow.svg
// module id = sgv1
// module chunks = 2